import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error505',
  templateUrl: './error505.component.html',
  styleUrls: ['./error505.component.css']
})
export class Error505Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/error505/error505.component.ts